module.exports = __webpack_public_path__ + "files/29faa83cae6845d08af2e4a0d9986ac8.svg";